import React from 'react'
import { observer } from 'mobx-react'
import { User } from 'models'
import { Box, Typography, Avatar as MUIAvatar } from '@mui/material'
import { stringToPaletteColor, toInitials } from 'util/util'
import { useTranslation } from 'react-i18next'

export interface IAvatarProps {
  user?:      User,
  name?:      string,
  email?:     string,
  height?:    string | number,
  width?:     string | number,
  hideEmail?: boolean,
  fakeEmail?: boolean,
}

export const Avatar = observer((props: IAvatarProps): JSX.Element => {
  const { user, height, width, name, hideEmail, fakeEmail } = props;
  const { t } = useTranslation();

  const display_name = name || user.getFullName || "";
  return (
    <Box display='flex' alignItems='center'>
      <MUIAvatar
        sx={{
          marginRight: '1rem',
          height: height || '4rem',
          width: width || '4rem',
          background: stringToPaletteColor(display_name),
        }}
      >
        <Typography>{toInitials(display_name)}</Typography>
      </MUIAvatar>
      <Box display='flex' flexDirection={!hideEmail ? 'column' : 'row'}>
        <Typography lineHeight={1}>{display_name}</Typography>
        {!hideEmail && (
          <Typography
            lineHeight={1}
            sx={(theme) => ({
              color: theme.palette.muted.main,
            })}
          >
            {fakeEmail ? t('email') : user.email}
          </Typography>
        )}
      </Box>
    </Box>
  )
});
